export default "__VITE_ASSET__BrH8$PWC__"